import { Routes, Route, Navigate } from "react-router";
import AutomationsPage from "./automations/index";
import WorkflowLogsPage from "./logs/index";

/**
 * Workflows module — ALL DONE.
 * B.7: Automations (visual DAG editor) — DONE
 * B.8: Logs (execution history, step replay) — DONE
 */
export default function WorkflowsPage() {
  return (
    <Routes>
      <Route index element={<Navigate to="automations" replace />} />
      <Route path="automations" element={<AutomationsPage />} />
      <Route path="logs" element={<WorkflowLogsPage />} />
    </Routes>
  );
}
